import * as React from "react";
import "styled-components/macro";
import { Flex } from "@rebass/grid";

import { tabBarHeight } from "../TabBar";
import { PropsWithChildren } from "react";

interface IDimensionColumnsProps extends PropsWithChildren<any> {
  noTabBarHeight?: boolean;
}

const DimensionColumns: React.FC<IDimensionColumnsProps> = ({ noTabBarHeight, children }) => (
  <Flex
    mt={4}
    css={{
      height: "100%",
      paddingBottom: noTabBarHeight ? "0" : `${tabBarHeight}`,
      width: "100%",
      overflow: noTabBarHeight ? "" : "scroll"
    }}
  >
    {children}
  </Flex>
);

export default DimensionColumns;
